import * as apis from "@/api";
import { conversion, GetItemDuration } from "@/tool";
import { mapState, mapMutations } from "vuex";
import Award from "@/components/award";
import Number from "@/components/AnimateNumber";

export default {
  components: {
    "c-award": Award,
    "c-number": Number,
  },
  data() {
    return {
      isShow: false,
      case_opened_awards: [],
      bgPos: 0,
    };
  },

  filters: {
    conversion,
    GetItemDuration,
  },
  computed: {
    ...mapState(["sellSound", "isMute"]),
    /** 开箱结果奖品金额合计 */
    case_opened_awards_amount: (vm) =>
      vm.case_opened_awards
        .filter((_) => !_.isConvert)
        .reduce((acc, { price }) => acc + price, 0),
  },
  methods: {
    reset() {
      this.case_opened_awards = [];
      this.isShow = false;
    },
    resetItem(index) {
      this.case_opened_awards[index].isConvert = true;
      if (this.case_opened_awards_amount <= 0) {
        this.reset();
      }
    },
    pushItem(name, mSerial, itempic, rarity, price, roll) {
      var typename = name.match(/^(.*?)\s?(\(.*\))?$/)[1];
      var skinname = "";
      var dur = GetItemDuration(name);
      var strArr = typename.split("|");
      if (strArr.length > 1) {
        typename = strArr[0];
        skinname = strArr[1];
      }

      this.case_opened_awards.push({
        name: name,
        typename,
        skinname,
        dur,
        mSerial,
        itempic,
        rarity,
        price,
        isConvert: false,
        roll,
      });
    },
    show() {
      this.bgPos = Math.floor(Math.random() * 100) % 3;
      this.isShow = true;
    },
    /** 开箱奖品折现 */
    async case_opened_awards_discount(award) {
      var awards_Serial = this.case_opened_awards
        .filter((_) => !_.isConvert)
        .map((award) => award.mSerial);

      if (award) {
        awards_Serial = [award.mSerial];
      }

      const awards_discount_response = await apis.api_SellItem({
        lstmSerial: awards_Serial,
      });

      // 折现失败
      if (awards_discount_response.data.code !== 0) {
        this.$toast.error(awards_discount_response.data.msg);
        return;
      }

      // if(!this.isMute){
      // 	this.sellSound.pause();
      // 	this.sellSound.currentTime=0;
      // 	this.sellSound.play();
      // }

      //this.awards_modal_flag = false;

      this.$toast.success(awards_discount_response.data.msg);

      // 更新用户信息
      this.$store.commit("setInfo");

      this.case_opened_awards.forEach((item, index) => {
        if (awards_Serial.indexOf(item.mSerial) > -1) {
          item.isConvert = true;
        }
      });

      if (this.case_opened_awards_amount <= 0) {
        this.reset();
      }
    },
  },
};
